export const esisModalTooltipMessages = {
  levelOfAdvice: 'Please indicate whether you have provided advice to this customer or not',
  feeWaiver: 'If any fees for this mortgage application are being waived please insert wording here',
};
